import moment from "moment";

// T6 — exit-survey worklist. Rows are auto-created by bot_churn.js /
// POST /v1/bo/churn/recompute the moment a member's transaction lapses
// (status "pending"); the retention team fills in reason_category /
// reason_text_raw / sentiment here after following up manually, since
// the automated 1-question Mailchimp survey isn't wired up yet (P1 scope).
const REASON_CATEGORIES = [
  "Harga/terlalu mahal",
  "Kurang waktu",
  "Konten kurang relevan",
  "Sudah cukup belajar",
  "Pindah platform lain",
  "Masalah teknis/UX",
  "Finansial pribadi",
  "Lainnya",
];

const SENTIMENTS = ["positif", "netral", "negatif"];

const STATUSES = ["pending", "answered", "skipped"];

let churnExitSurveySection = {
  name: "Exit Survey",
  slug: "churnExitSurvey",
  visible: true,
  singularName: "Exit Survey",
  crud: true,
  endpoint: "/crud/churn_exit_survey",
  updateLabel: "reason_category",
  filters: [],
  meta: {
    delete_flag: false,
  },
  access: ["superadmin"],
  delete: false,
  add: false,
  update: true,
  edit: false,
  exportToCsv: true,
  fields: [
    {
      label: "Trigger",
      input: false,
      resource_label: (row) => {
        if (!row || !row.trigger_date) return "-";
        return moment(row.trigger_date).tz("Asia/Jakarta").format("DD MMM YYYY HH:mm");
      },
    },
    {
      label: "Nama",
      name: "name",
      type: "text",
      input: false,
      resource_label: (row) => (row && row.name ? row.name : "-"),
    },
    {
      label: "Email",
      name: "email",
      type: "text",
      input: false,
      resource_label: (row) => (row && row.email ? row.email : "-"),
    },
    {
      label: "Event",
      name: "trigger_event",
      type: "text",
      input: false,
    },
    {
      label: "Alasan",
      name: "reason_category",
      type: "lookup",
      editable: true,
      values: REASON_CATEGORIES.map((r) => ({ value: r, text: r })),
      resource_label: (row) => (row && row.reason_category ? row.reason_category : "Belum diisi"),
      defaultValue: (row) => (row ? row.reason_category : null),
    },
    {
      label: "Sentiment",
      name: "sentiment",
      type: "lookup",
      editable: true,
      values: SENTIMENTS.map((s) => ({ value: s, text: s })),
      resource_label: (row) => (row && row.sentiment ? row.sentiment : "-"),
      defaultValue: (row) => (row ? row.sentiment : null),
    },
    {
      label: "Status",
      name: "status",
      type: "lookup",
      editable: true,
      values: STATUSES.map((s) => ({ value: s, text: s })),
      resource_label: (row) => (row && row.status ? row.status : "pending"),
      defaultValue: (row) => (row ? row.status : "pending"),
    },
  ],
};

export default [churnExitSurveySection];
